import { render } from "./CreateDomain.vue?vue&type=template&id=ce2b6836"
import script from "./CreateDomain.vue?vue&type=script&lang=js"
export * from "./CreateDomain.vue?vue&type=script&lang=js"

import "./CreateDomain.vue?vue&type=style&index=0&id=ce2b6836&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__